import {NamedActionExecuteNamed, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export enum PortalNamedActionOperation {
	NextPage = "nextpage",
	PrevPage = "prevpage",
	FirstPage = "firstpage",
	LastPage = "lastpage",
	Custom = "custom"
}

export class PortalNamedActionExecuteNamed extends NamedActionExecuteNamed implements Parameter {
	public operation?: PortalNamedActionOperation;

	constructor(data: any) {
		super(data);

		this.operation = FunctionHelper.exists(data?.operation) ? data.operation : PortalNamedActionOperation.NextPage;
	}

	public static getOperationDefault(): PortalNamedActionOperation {
		return PortalNamedActionOperation.NextPage;
	}

	public static fromJson(data: any): PortalNamedActionExecuteNamed {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalNamedActionExecuteNamed(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'operation': this.operation
		};
	}

	public clone(): PortalNamedActionExecuteNamed {
		return PortalNamedActionExecuteNamed.fromJson(this.toJson());
	}
}